import Api from '@/helper/api'
import { Message } from 'element-ui'
import COS from 'COS'
function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4()
}
window.TencentCosUpload = function (file, config = {}, blob) {
  return new Promise((resolve, reject) => {
    Api.post('/upload/getTmpAuthorization')
      .then((record) => {
        // 获取后缀
        var filename = `${record.url}${file.name}`
        if (!config.keepFileName) {
          // 获取最后一个.的位置
          var index = file.name.lastIndexOf('.')
          var ext = file.name.substr(index + 1)
          filename = `${record.url}${guid()}.${ext}`
        }
        var cos = new COS({
          getAuthorization (options, successCallback) {
            successCallback({
              TmpSecretId: record.tmpSecretId,
              TmpSecretKey: record.tmpSecretKey,
              XCosSecurityToken: record.sessionToken,
              ExpiredTime: record.expiredTime
            })
          }
        })
        cos.sliceUploadFile({
          Bucket: record.bucket,
          Region: record.region,
          Key: filename,
          Body: blob || file,
          StorageClass: 'STANDARD',
          onProgress: (progressData) => {
            config && config.onProgress && config.onProgress(progressData.percent)
          }
        }, (err, data) => {
          if (err) {
            Message.error('upload fail')
            reject(new Error('upload fail'))
          } else {
            resolve('https://' + data.Location)
          }
        })
      })
  })
}



// WEBPACK FOOTER //
// ./src/helper/global.js